<template>
  <div :isInvalid="isInvalid">
    <b-form-checkbox name="rulesCheckbox" size="sm"
                      class="d-inline-block"
                      v-model="internalValue"
                      :state="isInvalid ? false : null">
      <span class="text-neutral">Eu li e estou de acordo com as</span>
      <b-button v-b-modal.rules-modal variant="link"
                class="text-decoration-none link align-baseline px-1 py-0"
                @click.passive="checkTrack()">
        Regras de Divulgação
      </b-button>
    </b-form-checkbox>

    <b-modal id="rules-modal" title="Regras de Divulgação" size="lg"
             header-class="close-modal-header" title-class="rules-modal-title"
             modal-class="rules-modal" body-class="mr-3 custom-modal-body"
             footer-class="border-0 d-flex justify-content-center pt-1"
             scrollable centered>
      <template class="rules-modal-body">
        <slot name="rules" :closeComplianceModal="closeComplianceModal"></slot>
      </template>
      <template slot="modal-footer" slot-scope="{ close }">
        <b-button variant="orange" size="lg" class="main-action-button" @click="close()">
          Fechar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ComplianceField',
  props: {
    value: Boolean,
    isInvalid: Boolean,
    rulesModalTrackLabel: String,
  },
  data() {
    return {
      internalValue: false,
    };
  },
  methods: {
    checkTrack() {
      if (this.rulesModalTrackLabel) {
        this.track(this.rulesModalTrackLabel);
      }
      this.track('Abriu as Regras de divulgação');
    },
    closeComplianceModal() {
      this.$bvModal.hide('rules-modal');
    },
  },
  mounted() {
    this.internalValue = !!this.value;
  },
  watch: {
    internalValue(newValue) {
      this.$emit('input', newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.rules-modal-body {
  ul {
    padding-left: 2rem;
    li {
      line-height: 20px;
    }
  }
  p {
    padding-left: 1rem;
  }
}
</style>
